import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { AgGridReact } from "ag-grid-react";
import { ProjectContext } from "context/ProjectProvider";
import { getFeatureEntityLog } from "services/feature-apis";
import { FeatureTypes } from "entity-app/constants/index";
import useSubmittalLogGridConfig from "pages/submittal-log/hooks/submittal-log-grid-config";
import AgGridPrintLayout from "./ag-grid-print-layout";
import { SubmittalLogPrintViewState } from "./model";

function SubmittalLogPrintView({
  state
}: {
  state: SubmittalLogPrintViewState;
}) {
  const gridRef = useRef<AgGridReact<any>>(null);
  const { tokenRetrievalState } = useContext(ProjectContext);
  const { projectId } = useParams() as { projectId: string };
  const [rowData, setRowData] = useState<any[]>();
  const [rowLoading, setRowLoading] = useState(true);

  const fetchLogData = useCallback(async () => {
    setRowLoading(true);
    const res = await getFeatureEntityLog({
      projectToken: tokenRetrievalState?.token,
      featureType: FeatureTypes.SUBMITTALS
    });

    if (res.success) {
      setRowData([...res.data]);
    }
    setRowLoading(false);
  }, [tokenRetrievalState?.token]);

  useEffect(() => {
    if (tokenRetrievalState?.token) {
      fetchLogData();
    }
    return () => {};
  }, [fetchLogData, tokenRetrievalState?.token]);

  const maxNumberOfMilestones = {
    milestonesCount: 5,
    lastMilestoneHasOffset: false,
    milestoneIndicesWithOffset: new Set<number>()
  };

  const { gridColumnDefs } = useSubmittalLogGridConfig(
    projectId,
    gridRef,
    maxNumberOfMilestones
  );

  return (
    <AgGridPrintLayout
      gridRef={gridRef}
      state={state}
      columnDefEntity={gridColumnDefs}
      rowData={rowData}
      rowLoading={rowLoading}
    />
  );
}

export default SubmittalLogPrintView;
